export const RESOURCE_TYPE_ROADMAP = 'ROADMAP';
export const RESOURCE_TYPE_BOARD_CONTEXT_ROADMAP_SETTINGS = 'BOARD_CONTEXT_ROADMAP_SETTINGS';
